import React, {useEffect, useState} from 'react';
import {
  Pagination,
  Paper, Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import {formatPrice} from "src/functions/priceFormatter";
import {apiDateTimeStringToDate} from "src/api/apiDateTimeHandler";
import {format} from "date-fns";
import nextPaymentDateApi from "src/api/miscelleneous/nextPaymentDateApi";
import payoutBatchElementApi from "src/api/payment/payoutBatchElementApi";

const itemsPerPage = 10;

const PayoutBatchElementList = () => {
  const [nextPaymentDate, setNextPaymentDate] = useState();
  const [payoutBatchElements, setPayoutBatchElements] = useState([]);
  const [payoutBatchElementsCount, setPayoutBatchElementsCount] = useState();
  const [page, setPage] = useState(1);
  const pages = Math.ceil((payoutBatchElementsCount ?? 0) / itemsPerPage);

  const fetchPayoutBatchElements = async () => {
    const fetchedPayoutBatchElements = await payoutBatchElementApi.retrieveCollection({
      page: page,
      itemsPerPage: itemsPerPage,
      'order[payoutBatch.sentToBank]': 'ASC',
    })
    setPayoutBatchElements(fetchedPayoutBatchElements['hydra:member']);
    setPayoutBatchElementsCount(fetchedPayoutBatchElements['hydra:totalItems']);
  }

  useEffect(() => {
    fetchPayoutBatchElements();
  }, [page, itemsPerPage])

  const fetchNextPaymentDate = async () => {
    const fetchedNextPaymentDate = await nextPaymentDateApi.retrieveItem();
    setNextPaymentDate(apiDateTimeStringToDate(fetchedNextPaymentDate.nextPaymentDate));
  }

  useEffect(() => {
    fetchNextPaymentDate();
  }, []);

  function getFormattedPayDate(payoutBatchElement) {
    if (!payoutBatchElement.payoutBatch.payDate) {
      if (!nextPaymentDate) {
        return '';
      }

      return format(nextPaymentDate, 'd MMMM yyyy');
    }

    return format(apiDateTimeStringToDate(payoutBatchElement.payoutBatch.payDate), 'd MMMM yyyy');
  }

  if (payoutBatchElements && payoutBatchElements.length === 0) {
    return <Typography variant="body1" mb={2}>Er zijn nog geen betalingen naar je gedaan.</Typography>;
  }

  return (
    <Stack spacing={2}>
      <TableContainer component={Paper}>
        <Table sx={{m: 0}}>
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Ontvangen op</TableCell>
              <TableCell align="right">Referentie</TableCell>
              <TableCell align="right">Totaalbedrag</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payoutBatchElements && payoutBatchElements.map(payoutBatchElement => (
              <TableRow key={payoutBatchElement.id}>
                <TableCell>{payoutBatchElement.payoutBatch.status}</TableCell>
                <TableCell>{getFormattedPayDate(payoutBatchElement)}</TableCell>
                <TableCell align="right">{payoutBatchElement.id}</TableCell>
                <TableCell align="right">{formatPrice(payoutBatchElement.amount)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        count={pages}
        page={page}
        onChange={(e, newValue) => setPage(newValue)}
      />
    </Stack>
  );
}

export default PayoutBatchElementList;

PayoutBatchElementList.propTypes = {};

PayoutBatchElementList.defaultProps = {};
